import tw, { styled } from "twin.macro";
import sideMenuBg from "../../assets/svg/side_menu_bg.svg";

export const Wrapper = styled.div`
	${tw`m-0 p-0`}
	height: 100vh !important;
	width: 100vw !important;
	overflow: hidden;
	position: relative;

	.side {
		${tw`pt-6 pb-6 z-30!`}
		background: url(${sideMenuBg});
		background-repeat: repeat;
		background-size: cover;
		background-blend-mode: darken;
		background-color: #f4f4f8 !important;
		width: 250px;
		position: fixed;
		overflow: hidden;
		transition: width 0.3s;
		height: calc(100vh - 4.5rem);

		@media (max-width: 768px) {
			width: 0px;
			height: calc(100vh - 3.5rem);
		}
		/* @media (min-width: 769px) and (max-width: 1124px) {
			width: 24vw;
		} */
	}

	.page {
		background-color: #fdfefe !important;
		margin-left: 250px;
		margin-bottom: 20px;
		height: calc(100vh - 4.5rem);
		transition: margin-left 0.3s;
		overflow: hidden !important;
		position: relative;
		@media (max-width: 768px) {
			margin-left: 0px;
			height: calc(100vh - 3.5rem);
		}
	}
`;

export const SplitPlaneWrapper = styled.div`
	width: 100%;
	overflow-y: auto;
	height: calc(100vh - 4rem);
	@media (max-width: 768px) {
		height: calc(100vh - 3rem);
	}
`;
